var map = {
	"./black/gengxin2.png": "AIev",
	"./blue/gengxin2.png": "2Nv1",
	"./white/gengxin2.png": "En+6"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ZxUU";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/gengxin2\.png$
// module id = ZxUU
// module chunks = 24